export const estimatesIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><g fill="none" stroke="currentColor"><path d="M1 1h18v18H1zm12 8.412v-4.8m0 10.8v-2.4"/><path d="M14.8 11.212a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0zm-7.8-3v7.2m1.8-9a1.8 1.8 0 1 0-3.6 0 1.8 1.8 0 0 0 3.6 0z"/></g></svg>`,
    name: 'estimates' as const
};